import { useEffect, useState } from "react";
import { hieraApi } from "../lib/api";
import { t, type Lang } from "../lib/i18n";

type Props = {
  lang: Lang;
  initialQuery?: string;
  onClose: () => void;
  onOpen: (path: string) => void;
};

export function CommandPalette({ lang, initialQuery = "", onClose, onOpen }: Props) {
  const [q, setQ] = useState(initialQuery);
  const [results, setResults] = useState<Array<Record<string, unknown>>>([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = window.setTimeout(() => {
      if (!q.trim()) {
        setResults([]);
        return;
      }
      void hieraApi.search(q.trim()).then((r) => setResults(r.results));
    }, 150);
    return () => window.clearTimeout(id);
  }, [q]);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowDown") setIdx((i) => Math.min(results.length - 1, i + 1));
      if (e.key === "ArrowUp") setIdx((i) => Math.max(0, i - 1));
      if (e.key === "Enter" && results[idx]) {
        onOpen(`/p/${results[idx].id}`);
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [results, idx, onClose, onOpen]);

  return (
    <div className="palette-backdrop" onClick={onClose}>
      <div className="palette" onClick={(e) => e.stopPropagation()} role="dialog">
        <input
          autoFocus
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            setIdx(0);
          }}
          placeholder={t(lang, "search")}
        />
        <ul>
          {results.map((r, i) => (
            <li key={String(r.id)} className={i === idx ? "active" : ""}>
              <button type="button" onClick={() => onOpen(`/p/${r.id}`)}>
                <strong>{String(r.title)}</strong>
                <span className="status-line">
                  {String(r.space_title)}
                  {String(r.status) !== "published" ? <span className="pill">{String(r.status)}</span> : null}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
